import { render, staticRenderFns } from "./ExportStatisticsMenu.vue?vue&type=template&id=8a445032&scoped=true&"
import script from "./ExportStatisticsMenu.vue?vue&type=script&lang=js&"
export * from "./ExportStatisticsMenu.vue?vue&type=script&lang=js&"
import style0 from "./ExportStatisticsMenu.vue?vue&type=style&index=0&id=8a445032&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a445032",
  null
  
)

export default component.exports